const Planning = {
    state: {
        planningList: []
    },
    mutations: {
        ADD_PLANNING(state, plan) {
            state.planningList.push(plan);
        },
        REFRESH_PLANNING(state) {
            //state.planningList.length = 0;
            state.planningList.splice(0, state.planningList.length);
        },
        DELETE_PLANNING_UNIT(state, payload) {
            let tempPlan = state.planningList.find(function (item) {
                return item.term_key === payload.object.term && item.year_id === payload.year.id;
            });
            if (tempPlan) {

                // let r = tempPlan.units.findIndex(function (i) {
                //     return i.identifier === payload.object.identifier;
                // })

                tempPlan.units.splice(
                    tempPlan.units.findIndex(function (i) {
                        return i.identifier === payload.object.identifier;
                    }),
                    1
                )
            }
        },
        ADD_PLANNING_UNIT(state, payload) {
            let tempPlan = state.planningList.find(function (item) {
                return item.term_key === payload.term && item.year_id === payload.year;
            });
            if (tempPlan) {
                 alert(JSON.stringify(payload));
                tempPlan.units.push(payload);
            }
        },
        setChallenge(state, payload) {
            state.challenge = payload;
        }
    },
    getters: {
        planningList: state => state.planningList
    }
};

export default Planning;
